(() => {
  const toplistData = {
    order: 'default',
    filters: [],
  };

  const isMobile = () => window.innerWidth <= 575;

  const addDocumentOverflow = () => {
    const overlayEl = document.querySelector('.cp-overlay');
    overlayEl.classList.remove('d-none');
    document.querySelector('html').style.overflow = 'hidden';
  };

  const removeDocumentOverflow = () => {
    document.querySelector('html').style.overflow = null;
    const overlayEl = document.querySelector('.cp-overlay');
    overlayEl.classList.add('d-none');
  };

  // const getParents = (e) => {
  //   var result = [];
  //   for (var p = e && e.parentElement; p; p = p.parentElement) {
  //     result.push(p);
  //   }
  //   return result;
  // };

  let openedFilters = false;

  const getSiblings = (e) => {
    // for collecting siblings
    const siblings = [];
    // if no parent, return no sibling
    if (!e.parentNode) {
      return siblings;
    }
    // first child of the parent node
    let sibling = e.parentNode.firstChild;

    // collecting siblings
    while (sibling) {
      if (sibling.nodeType === 1 && sibling !== e) {
        siblings.push(sibling);
      }
      sibling = sibling.nextSibling;
    }
    return siblings;
  };

  const htmlToElement = (html) => {
    var template = document.createElement('template');
    html = html.trim(); // Never return a text node of whitespace as the result
    template.innerHTML = html;
    return template.content.firstChild;
  };

  const getToplistBody = async (postId) => {
    try {
      const data = new FormData();
      data.append('action', 'get_toplist_ajax');
      data.append('order', toplistData.order);
      data.append('filters', toplistData.filters);
      data.append('post_id', postId);
      const response = await fetch(theme_js.ajaxurl, {
        method: 'POST',
        body: data,
      });
      return await response.text();
    } catch (err) {
      console.error(err);
    }
  };

  const initTopList = () => {
    const toplistTableEls = document.querySelectorAll('.toplist__table');

    const initTableHeads = (headEls, tableEl) => {
      let tbodyEl = tableEl.querySelector('tbody');
      const postId = tableEl.dataset.postId;
      for (let headEl of headEls) {
        const headName = headEl.dataset['name'];
        let isFilters = headName === 'filters';
        const buttonEl = headEl.querySelector('button');
        const containerEl = headEl.querySelector('.toplist__head-container');
        const closeBtnEl = headEl.querySelector('.close-btn');

        const isOpened = (customContainerEl) => {
          return !(customContainerEl || containerEl).classList.contains(
            'd-none'
          );
        };

        const open = () => {
          containerEl.classList.remove('d-none');
          if (isMobile() && containerEl.parentNode.dataset.name === 'filters') {
            addDocumentOverflow();
            openedFilters = true;
          }
          if (headName === 'order') {
            let left = null;
            if (window.innerWidth > 767) {
              const spanEl = containerEl.previousElementSibling;
              if (spanEl) {
                const { width: containerWidth } =
                  containerEl.getBoundingClientRect();
                const { width: spanWidth } = spanEl.getBoundingClientRect();
                left = `-${containerWidth - spanWidth - 13}px`;
              }
            }
            containerEl.style.left = left;
          }
        };

        const close = (customContainerEl) => {
          const el = customContainerEl || containerEl;
          el.classList.add('d-none');
          if (isMobile() && el.parentNode.dataset.name === 'filters') {
            removeDocumentOverflow();
            openedFilters = false;
          }
        };

        let hasUpdatedMobileNoresults = false;

        const updateMobileNoresults = () => {
          if (isMobile() || hasUpdatedMobileNoresults) {
            const noResultsTrEl = tbodyEl.querySelector('tr.no-results');
            // const resultsNumTrEl = tbodyEl.querySelector('tr.results-num');
            if (noResultsTrEl) {
              const div = noResultsTrEl.querySelector('div');
              const nextTr = noResultsTrEl.nextElementSibling;
              const { height } = div.getBoundingClientRect();
              noResultsTrEl.style.height = `${height + 20}px`;
              let marginTop = 20 * 2 + height;
              // if (resultsNumTrEl) {
              //   marginTop += 15 * 2;
              // }
              nextTr.style.marginTop = `${marginTop}px`;
            }
            hasUpdatedMobileNoresults = true;
          }
        };
        window.addEventListener('resize', updateMobileNoresults, {
          passive: true,
        });

        const updateTableBody = async () => {
          const body = await getToplistBody(postId);
          const newTbody = htmlToElement(body);
          tbodyEl.replaceWith(newTbody);
          tbodyEl = tableEl.querySelector('tbody');
          updateMobileNoresults();
        };

        closeBtnEl?.addEventListener('click', (el) => {
          close();
        });

        buttonEl.addEventListener('click', (el) => {
          el.stopPropagation();
          if (isOpened()) {
            close();
          } else {
            open();
          }
          for (const el of headEls) {
            if (el.dataset.name !== headName) {
              // console.log('close', el.dataset.name);
              close(el.querySelector('.toplist__head-container'));
            }
          }
        });
        const onClick = (event) => {
          const selectedLi = event.target.closest('li');
          if (selectedLi) {
            const selectedValue = selectedLi.dataset.value;
            const isLocalMultiple =
              selectedLi.parentNode.dataset.multiple != null;
            // console.log('isLocalMultiple', isLocalMultiple);
            const allValuesOnPage = document.querySelectorAll(
              `[data-value="${selectedValue}"]`
            );
            if (isFilters && isLocalMultiple) {
              allValuesOnPage.forEach((v) => {
                v.classList.toggle('selected');
                if (!v.getAttribute('aria-selected')) {
                  v.setAttribute('aria-selected', 'true');
                } else {
                  v.removeAttribute('aria-selected');
                }
              });
            } else {
              const siblings = [];
              allValuesOnPage.forEach((v) => {
                siblings.push(...getSiblings(v));
              });
              siblings.forEach((v) => {
                v.classList.remove('selected');
                v.removeAttribute('aria-selected');
              });
              allValuesOnPage.forEach((v) => {
                v.classList.toggle('selected');
                if (!v.getAttribute('aria-selected')) {
                  v.setAttribute('aria-selected', 'true');
                } else {
                  v.removeAttribute('aria-selected');
                }
              });
              if (!isFilters) {
                toplistData[headName] = selectedValue;
              }
            }
            if (isFilters) {
              toplistData[headName] = [];
              const headContainerEl = selectedLi.closest(
                '.toplist__head-container'
              );
              const allSelectedItems =
                headContainerEl.querySelectorAll('.section .selected');
              for (const item of allSelectedItems) {
                toplistData[headName].push(item.dataset.value);
              }
            }
            updateTableBody();
          }
        };
        containerEl.addEventListener('keydown', (event) => {
          if (event.keyCode === 13) {
            console.log('ENTER');
            onClick(event);
          }
        });
        containerEl.addEventListener('click', async (event) => {
          event.stopPropagation();
          onClick(event);
        });
        document.addEventListener('click', (e) => {
          if (isOpened() && !containerEl.contains(e.target)) {
            close();
          }
        });
      }
    };

    toplistTableEls.forEach((tableEl) => {
      const headEl = tableEl.previousElementSibling;
      const headEls = headEl.children;

      // mobile
      initTableHeads(headEls, tableEl);

      const desktopHeadEls = tableEl.querySelectorAll(
        'thead .toplist__head > div'
      );
      // desktop
      initTableHeads(desktopHeadEls, tableEl);
    });
  };
  const setCookie = (name, value, expire) => {
    const expireDate = new Date();
    expireDate.setDate(expireDate.getDate() + expire);
    document.cookie =
      name +
      '=' +
      escape(value) +
      '; expires=' +
      expireDate.toGMTString() +
      '; path=/';
  };

  const ajaxRequest = (url, data, callback) => {
    try {
      const x = new XMLHttpRequest();
      x.open('POST', url, 1);
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      x.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      x.onreadystatechange = () => {
        x.readyState > 3 && callback && callback(x.responseText, x);
      };
      const formParts = [];
      for (let prop in data) {
        const val = data[prop];
        formParts.push(`${prop}=${encodeURIComponent(val)}`);
      }
      x.send(formParts.join('&'));
    } catch (e) {
      console.error(e);
      callback(null, e);
    }
  };

  const live = (eventType, elementQuerySelector, cb) => {
    document.addEventListener(eventType, (event) => {
      const qs = document.querySelectorAll(elementQuerySelector);
      if (qs) {
        let el = event.target,
          index = -1;
        while (el && (index = Array.prototype.indexOf.call(qs, el)) === -1) {
          el = el.parentElement;
        }
        if (index > -1) {
          cb.call(el, event);
        }
      }
    });
  };

  const initSitemap = () => {
    const sitemapEl = document.querySelector('.sitemap.container');
    if (!sitemapEl) return;
    const sections = sitemapEl.querySelectorAll('section');
    sections.forEach((el) => {
      const showHidden = el.querySelector('.sitemap__show-hidden');
      if (showHidden) {
        showHidden.addEventListener(
          'click',
          () => {
            el.classList.add('visible');
          },
          {
            passive: true,
          }
        );
      }
    });
  };

  const initStickyHeader = () => {
    const stickyHeaderEl = document.querySelector(
      '.mobile-header__container-bottom'
    );
    const mainMenuEl = document.querySelector('.mobile-header__container');
    const documentEl = document.querySelector('.wrap');
    if (!stickyHeaderEl) return;

    const toplistHeadEls = document.querySelectorAll(
      '.toplist__head .toplist__head-filters .toplist__head-container'
    );

    let lastKnownScrollPosition = 0;
    let ticking = false;

    const onScrollRequest = (scrollPos) => {
      const { height } = stickyHeaderEl.getBoundingClientRect();
      if (isMobile()) {
        if (scrollPos > mainMenuEl.offsetHeight) {
          stickyHeaderEl.classList.add('sticky');
          documentEl.style.marginTop = `${mainMenuEl.offsetHeight + 7}px`;
        } else {
          stickyHeaderEl.classList.remove('sticky');
          documentEl.style.marginTop = 0;
        }
        toplistHeadEls.forEach((v) => {
          v.style.top = `${height}px`;
        });

        if (openedFilters) {
          addDocumentOverflow();
        }
      } else {
        if (openedFilters) {
          removeDocumentOverflow();
        }

        stickyHeaderEl.classList.remove('sticky');
        toplistHeadEls.forEach((v) => {
          v.style.top = null;
        });
      }
    };

    const onScroll = () => {
      lastKnownScrollPosition = window.scrollY;
      if (!ticking) {
        window.requestAnimationFrame(() => {
          onScrollRequest(lastKnownScrollPosition);
          ticking = false;
        });

        ticking = true;
      }
    };

    document.addEventListener('scroll', onScroll, {
      passive: true,
    });
    window.addEventListener('resize', onScroll, {
      passive: true,
    });
    onScroll();
  };

  document.addEventListener('DOMContentLoaded', () => {
    initSitemap();
    initStickyHeader();
    initTopList();
    const primaryMenu = document.querySelector('.header__primary');
    const burgerBtn = document.querySelector('.header__toggle-btn');
    burgerBtn?.addEventListener(
      'click',
      () => {
        primaryMenu.classList.toggle('opened');
        setCookie(
          'primary_menu_opened',
          primaryMenu.classList.contains('opened') ? 1 : 0,
          30 * 12
        );
      },
      {
        passive: true,
        capture: false,
      }
    );

    (() => {
      const body = document.body,
        bMenu = document.getElementsByClassName('b-menu')[0],
        bContainer = document.getElementsByClassName('b-container')[0],
        bNav = document.getElementsByClassName('b-nav')[0];
      bMenu?.addEventListener(
        'click',
        () => {
          [body, bContainer, bNav].forEach((n) => {
            n.classList.toggle('open');
          });
        },
        !1
      );
    })();

    const toggleSlow = (elSelector, toggleSelector) => {
      const el = document.querySelector(elSelector);
      el?.addEventListener('click', (e) => {
        e.preventDefault();
        const el2 = document.querySelector(toggleSelector);
        el2.classList.toggle('slow');
      });
    };
    toggleSlow('.filter-guides', '.guides');
    toggleSlow('.filter-news', '.news');
    toggleSlow('.filter-slots', '.slots');

    live('click', 'a[href^="#"]:not(.ez-toc-link)', (e) => {
      e.preventDefault();
      const href = e.target.getAttribute('href');
      const offsetTop = document.querySelector(href)?.offsetTop - 80;
      if (window.scroll) {
        scroll({
          top: offsetTop,
          behavior: 'smooth',
        });
      } else {
        (document.scrollingElement || document.documentElement).scrollTop =
          offsetTop;
      }
    });

    const faqItemEls = document.querySelectorAll('.faq__item');
    const openClass = 'opened';
    faqItemEls.forEach((item) => {
      item.addEventListener('click', () => {
        const container = item.querySelector('.faq__item-content');
        if (!item.classList.contains(openClass)) {
          item.classList.add(openClass);
          container.style.height = 'auto';
          let height = container.clientHeight + 'px';
          container.style.height = '0px';
          setTimeout(() => {
            container.style.height = height;
          }, 0);
        } else {
          container.style.height = '0px';
          container.addEventListener(
            'transitionend',
            () => {
              item.classList.remove(openClass);
            },
            {
              once: true,
            }
          );
        }
      });
    });

    const btnsLoadMore = document.querySelectorAll('.btn-load-more');
    btnsLoadMore.forEach((btnLoadMore) => {
      btnLoadMore?.addEventListener('click', () => {
        const parentParent = btnLoadMore.parentElement?.parentElement;
        const table = parentParent.querySelector('table');
        const tbody = table?.querySelector('tbody');
        const itemsCount = tbody?.children.length;
        const authorId = btnLoadMore.dataset.authorId;
        const type = btnLoadMore.dataset.type;
        btnLoadMore.disabled = true;
        ajaxRequest(
          theme_js.ajaxurl,
          {
            action: 'author_load_more',
            itemsCount: itemsCount,
            authorId: authorId,
            type: type,
          },
          (response, err) => {
            try {
              const resp = JSON.parse(response);
              if (resp.success && resp.data) {
                const posts = resp.data.posts;
                if (!posts.length || resp.data.has_next === false) {
                  btnLoadMore.remove();
                }
                posts.forEach((v) => {
                  const tr = document.createElement('tr');
                  v.forEach((v2) => {
                    const tempTr = document.createElement('tr');
                    tempTr.innerHTML = v2;
                    tr.appendChild(tempTr.firstChild);
                  });
                  tbody.appendChild(tr);
                });
              }
            } catch (err) {}
            btnLoadMore.disabled = false;
          }
        );
      });
    });
    const countdownTimers = document.querySelectorAll('.countdown-timer__item');
    if (countdownTimers.length) {
      const dateDiff = (date1, date2) => {
        // get total seconds between the times
        let delta = Math.abs(date1 - date2) / 1000;
        // calculate (and subtract) whole days
        const days = Math.floor(delta / 86400);
        delta -= days * 86400;
        // calculate (and subtract) whole hours
        const hours = Math.floor(delta / 3600) % 24;
        delta -= hours * 3600;
        // calculate (and subtract) whole minutes
        const minutes = Math.floor(delta / 60) % 60;
        delta -= minutes * 60;
        // what's left is seconds
        const seconds = delta % 60; // in theory the modulus is not required
        return {
          day: days,
          hour: hours,
          minute: minutes,
          second: seconds,
          diff: (date1 - date2) / 1000,
        };
      };
      const timers = [];

      countdownTimers.forEach((v) => {
        const datetimeEnd = v.dataset.end;
        if (datetimeEnd) {
          const utcEndDatetime = new Date(
            Date.UTC.apply(this, datetimeEnd.split(','))
          );
          const timerFunc = () => {
            const currentDate = new Date();
            const utcCurrentDate = new Date(currentDate.toUTCString());
            const dateDiffObj = dateDiff(utcEndDatetime, utcCurrentDate);
            if (dateDiffObj.diff > 0) {
              if (dateDiffObj.day === 0) {
                if (v.classList.contains('countdown-timer__item--days')) {
                  v.classList.remove('countdown-timer__item--days');
                  v.classList.add('countdown-timer__item--hours');
                }
              } else {
                delete dateDiffObj.second;
              }
              for (const k in dateDiffObj) {
                const v = dateDiffObj[k];
                const text = `${v}`.length === 1 ? '0' + v : v;
                const el = v.querySelector(`.time-part.${k}`);
                const prevText = el.innerText;
                if (prevText !== `${text}`) {
                  el.innerHTML = text;
                }
              }
            }
            return dateDiffObj.diff;
          };
          timerFunc();
          timers[i] = setInterval(() => {
            const dateDiff = timerFunc();
            if (dateDiff <= 0) {
              clearInterval(timers[i]);
            }
          }, 100);
        }
      });
    }
  });
})();
